import type { IconSvgObject } from './types';

const TrafficConeIcon: IconSvgObject = [
  ["path", { d: "M2 21H22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 21L14.0095 4.41083C13.7037 3.56419 12.9001 3 12 3C11.0999 3 10.2963 3.56419 9.99053 4.41083L4 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 9H15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M6.5 15H17.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default TrafficConeIcon;
